import { Action } from '@ngrx/store';
import { Site } from '../../sites.model';

export enum ActionType {

  ADD_SITE = 'ADD_SITE',
  ADD_SITE_SUCCESS = 'ADD_SITE SUCCESS',
  ADD_SITE_FAILED = 'ADD_SITE FAILED',
  DELETE_SITE = 'DELETE_SITE',
  DELETE_SITE_SUCCESS = 'DELETE_SITE SUCCESS',
  DELETE_SITE_FAILED = 'DELETE_SITE FAILED',
  FETCH_SITES = 'FETCH SITES',
  FETCH_SITES_SUCCESS = 'FETCH SITES SUCCESS',
  FETCH_SITES_FAILED = 'FETCH SITES FAILED',
  UPDATE_SITE = 'UPDATE SITE',
  UPDATE_SITE_SUCCESS = 'UPDATE SITE SUCCESS',
  UPDATE_SITE_FAILED = 'UPDATE SITE FAILED',
  FETCH_SITES_BY_COMPANYID = 'FETCH SITES BY COMPANYID',
  FETCH_SITES_BY_COMPANYID_SUCCESS = 'FETCH SITES BY COMPANYID SUCCESS',
  FETCH_SITES_BY_COMPANYID_FAILED = 'FETCH SITES BY COMPANYID FAILED',
  DESTROY_SITE = 'DESTROY_SITE',
  DESTROY_SITE_SUCCESS = 'DESTROY_SITE SUCCESS',
  DESTROY_SITE_FAILED = 'DESTROY_SITE FAILED',
  FETCH_SITES_BY_COMPANYIDSITEID = 'FETCH SITES BY COMPANYIDSITEID',
  FETCH_SITES_BY_COMPANYIDSITEID_SUCCESS = 'FETCH SITES BY COMPANYIDSITEID SUCCESS',
  FETCH_SITES_BY_COMPANYIDSITEID_FAILED = 'FETCH SITES BY COMPANYIDSITEID FAILED',
}

export class DestroySite implements Action {
  readonly type = ActionType.DELETE_SITE;

  constructor(public id: string) { }
}

export class DestroySiteSuccess implements Action {
  readonly type = ActionType.DELETE_SITE_SUCCESS;

  constructor(public id: string) { }
}

export class DestroySiteFailed implements Action {
  readonly type = ActionType.DELETE_SITE_FAILED;

  constructor() { }
}

export class FetchSitesByCompanyIdSiteId implements Action {
  readonly type = ActionType.FETCH_SITES_BY_COMPANYIDSITEID;
  constructor(public companyId: string, public siteId: string) { }
}

export class FetchSitesByCompanyIdSiteIdSuccess implements Action {
  readonly type = ActionType.FETCH_SITES_BY_COMPANYIDSITEID_SUCCESS;
  constructor(public sites: Site[]) { }
}

export class FetchSitesByCompanyIdSiteIdFailed implements Action {
  readonly type = ActionType.FETCH_SITES_BY_COMPANYIDSITEID_FAILED;
  constructor(public error: any) { }
}

export class FetchSitesByCompanyId implements Action {
  readonly type = ActionType.FETCH_SITES_BY_COMPANYID;
  constructor(public companyId: string) { }
}

export class FetchSitesByCompanyIdSuccess implements Action {
  readonly type = ActionType.FETCH_SITES_BY_COMPANYID_SUCCESS;
  constructor(public sites: Site[]) { }
}

export class FetchSitesByCompanyIdFailed implements Action {
  readonly type = ActionType.FETCH_SITES_BY_COMPANYID_FAILED;
  constructor(public error: any) { }
}

export class FetchSites implements Action {
  readonly type = ActionType.FETCH_SITES;
  constructor() { }
}

export class FetchSitesSuccess implements Action {
  readonly type = ActionType.FETCH_SITES_SUCCESS;
  constructor(public sites: Site[]) { }
}

export class FetchSitesFailed implements Action {
  readonly type = ActionType.FETCH_SITES_FAILED;
  constructor(public error: any) { }
}

export class AddSite implements Action {
  readonly type = ActionType.ADD_SITE;

  constructor(public site: Site) { console.log('site', site); }
}

export class AddSiteSuccess implements Action {
  readonly type = ActionType.ADD_SITE_SUCCESS;

  constructor(public site: Site) { }
}

export class AddSiteFailed implements Action {
  readonly type = ActionType.ADD_SITE_FAILED;

  constructor() { }
}

export class DeleteSite implements Action {
  readonly type = ActionType.DELETE_SITE;

  constructor(public id: string) { }
}

export class DeleteSiteSuccess implements Action {
  readonly type = ActionType.DELETE_SITE_SUCCESS;

  constructor(public id: number) { }
}

export class DeleteSiteFailed implements Action {
  readonly type = ActionType.DELETE_SITE_FAILED;

  constructor() { }
}

export class UpdateSite implements Action {
  readonly type = ActionType.UPDATE_SITE;

  constructor(public site: Site) { }
}

export class UpdateSiteSuccess implements Action {
  readonly type = ActionType.UPDATE_SITE_SUCCESS;

  constructor(
    public id: string,
    public changes: Partial<Site>,
  ) { console.log('changes' , changes); }
}

export class UpdateSiteFailed implements Action {
  readonly type = ActionType.UPDATE_SITE_FAILED;

  constructor() { }
}

export type SiteActions =
  AddSite | AddSiteFailed | AddSiteSuccess |
  UpdateSite | UpdateSiteSuccess | UpdateSiteFailed |
  DeleteSite | DeleteSiteSuccess | DeleteSiteFailed |
  FetchSites | FetchSitesSuccess | FetchSitesFailed |
  FetchSitesByCompanyId | FetchSitesByCompanyIdSuccess | FetchSitesByCompanyIdFailed |
  FetchSitesByCompanyIdSiteId | FetchSitesByCompanyIdSiteIdSuccess | FetchSitesByCompanyIdSiteIdFailed |
  DestroySite | DestroySiteSuccess | DestroySiteFailed
  ;



